
export enum MessagePriorityCd {
	HIGH = 'High',
	LOW = 'Low'}
